<script setup>
// Imports
import OmniDialogHeader from 'components/UI/Dialogs/OmniDialogHeader.vue'

// Props
const componentProps = defineProps({
  dialogIcon: { type: String, default: 'palette' },
  autoUpdate: {
    type: Boolean,
    required: false,
    default: false,
  },
  showButtons: {
    type: Boolean,
    required: false,
    default: false,
  },
  defaultValue: {
    type: String,
    required: false,
    default: '#000000',
  },
  formatModel: {
    type: String,
    required: false,
    default: 'hex',
  },
  error: {
    type: Boolean,
    required: false,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: '',
  },
  label: {
    type: String,
    required: false,
    default: undefined,
  },
  hideTitleBar: {
    type: Boolean,
    required: false,
    default: false,
  },
  readonly: {
    type: Boolean,
    required: false,
    default: false,
  },
  persistent: {
    type: Boolean,
    required: false,
    default: true,
  },
})
const selectedColor = defineModel({ type: String, required: true })

// Refs
const showColorDialog = ref(false)
const selectedColorRef = ref(selectedColor.value)

// Methods
const applyColor = () => {
  selectedColor.value = selectedColorRef.value
  showColorDialog.value = false
}

// Watchers
watchEffect(() => {
  if (componentProps.autoUpdate) {
    selectedColor.value = selectedColorRef.value
  }
})
</script>

<template>
  <q-input v-model="selectedColor" :label="label" :readonly="readonly" outlined :error="error" :error-message="errorMessage" maxlength="7" v-bind="$attrs">
    <template #append>
      <div
        class="bordered rounded-borders"
        :class="{ 'cursor-pointer': !readonly, 'cursor-not-allowed': readonly }"
        :style="`border: 1px solid grey !important; height: 24px; width: 24px; background-color: ${selectedColor}`"
        @click="!readonly ? (showColorDialog = !showColorDialog) : null"
      />
    </template>
  </q-input>
  <q-dialog v-model="showColorDialog" :persistent="persistent && (!hideTitleBar || showButtons)">
    <q-card class="q-pa-none">
      <omni-dialog-header v-if="!hideTitleBar" :icon="dialogIcon" :title="$t('Shared.Globals.Color')" :subtitle="$t('Shared.DialogSubtitles.actions.color')">
        <template #actions>
          <q-btn v-close-popup dense flat round icon="close" :aria-label="$t('Shared.Globals.Close')">
            <q-tooltip>{{ $t('Shared.Globals.Close') }}</q-tooltip>
          </q-btn>
        </template>
      </omni-dialog-header>
      <q-card-section :class="{ 'q-pa-none': hideTitleBar && !showButtons }">
        <q-color :readonly="readonly" v-model="selectedColorRef" :format-model="formatModel" :default-value="defaultValue" v-bind="$attrs" class="bordered" />
      </q-card-section>
      <q-card-actions v-if="showButtons" align="right">
        <q-btn :disable="readonly" flat :label="$t('Shared.Globals.Cancel')" v-close-popup />
        <q-btn :disable="readonly" flat :label="$t('Shared.Globals.Apply')" @click="applyColor" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped></style>
